{
  "moreActions": "Mehr Aktionen",
  "unavailable": "Nicht verfügbar, für Details erweitern"
}
